<template>
  <div class="animated fadeIn">
    <DetailsHeader ref="DetailsHeader" v-on:SectionApproval="onSectionApproval" v-on:Approval="onApproval" v-on:Disapproval="onDisapproval"/>
    <div class="row">
      <div class="col-12">
        <div class="card card-bottom-radius-8" style="background-color: #f9f9f9;">
          <div class="card-block">
            <div v-if="this.objItems">
              <div v-for="(item, index) in this.objItems" :key="index" class="pb-5" style="float:left;">
                <div class="pl-2 pr-2">
                  <img v-if="item.arquivoNome" src="/static/img/comprovante_despesa.jpg" alt="Comprovante" class="img-thumbnail">
                  <div v-else class="img-thumbnail text-center pt-3 pb-3" style="width: 235px;height: 250px;background-color: #fcfcc8;">
                    <div><strong :style="item.incorrida ? 'text-decoration: line-through': ''">{{moment(item.dataDespesa).format('DD/MM/YYYY')}}</strong></div>
                    <div class="pt-2"><strong :style="item.incorrida ? 'text-decoration: line-through': ''">{{item.despesaTipo.nome}}</strong></div>
                    <div class="pt-3">
                      <table class="table table-striped table-bordered">
                        <thead class="thead-third" style="font-size: 9px">
                          <th scope="col">
                            TIPO
                          </th>
                          <th scope="col">
                            QTDE.
                          </th>
                          <th scope="col">
                            VALOR
                          </th>
                          <th scope="col">
                            TOTAL
                          </th>
                        </thead>
                        <tbody style="font-size: 9px">
                          <tr scope="row">
                            <td :style="item.incorrida ? 'text-decoration: line-through': ''">{{item.forma == 1 ? 'C' : 'D'}}</td>
                            <td :style="item.incorrida ? 'text-decoration: line-through': ''">{{item.quantidade}}</td>
                            <td :style="item.incorrida ? 'text-decoration: line-through': ''">{{formatMoney(item.valorUnitario)}}</td>
                            <td :style="item.incorrida ? 'text-decoration: line-through': ''">{{(formatMoney(item.valorTotal))}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      Comprovante não encontrado!
                      <div v-if="item.incorrida" class="pt-2"><strong><u>MOTIVO INCORRIDA</u></strong><br><div class="text-danger">{{item.motivoIncorrida}}</div></div>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <button type="button"
                          class="btn btn-danger btn-sm mr-1"
                          v-b-tooltip.hover
                          title="Clique para Reprovar"
                          v-if="!item.forma && !item.incorrida"
                          @click="showModalDisapproved(item.id)">
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </div>
            </div>
            <div v-else class="text-center pt-4 pb-4">
              <h5>Nenhum comprovante anexado!</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDisapproved ref="ModalDisapproved" v-on:Reload="setReload" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import DetailsHeader from './components/headerdetails.vue'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'
import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import ModalDisapproved from '@/views/private/finance/expenses/miscellaneous/details/components/modal/disapproved/modalDisapproved.vue'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'MiscellaneousExpenseAttachment',
  mixins: [ ActionsForm ],
  data () {
    return {
      objSelected: null,
      objItems: null
    }
  },
  components: {
    DetailsHeader,
    ModalDisapproved
  },
  methods: {
    onLoad () {
    },
    onEditExpense (obj) {
      if (obj) {
        this.objSelected = obj
        this.$refs.DetailsHeader.obj = obj
        this.onLoadAllExpenseItem(obj)
      }
    },
    showModalDisapproved (id) {
      var selected = []
      selected[0] = id
      this.$refs.ModalDisapproved.showModal(this.objSelected, selected)
    },
    onLoadAllExpenseItem (obj) {
      loading.push()
      ExpenseItemRepository.GetAll(obj.id)
        .then((response) => {
          if (response.data.code >= 0) {
            this.objItems = response.data.data
            loading.close()
          }
        })
        .catch(this.onException)
    },
    setReload () {
      if (this.objSelected) {
        this.onEditExpense(this.objSelected)
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onSectionApproval (obj) {
      if (obj) {
        loading.push()
        obj.situacao = 2
        ExpenseRepository.SetApproved(obj.id, obj.situacao)
          .then((response) => {
            this.onResult(response)
            this.objSelected = obj
            this.$refs.DetailsHeader.obj = obj
            loading.close()
          })
          .catch(this.onException)
      }
    },
    onApproval (obj) {
      if (obj) {
        loading.push()
        var situation = parseInt(obj.situacao) + 1
        obj.situacao = situation
        ExpenseRepository.SetApproved(obj.id, situation)
          .then((response) => {
            this.onResult(response)
            this.objSelected = obj
            this.$refs.DetailsHeader.obj = obj
            loading.close()
          })
          .catch(this.onException)
      }
    },
    onDisapproval (obj) {
      if (obj) {
        loading.push()
        var situation = parseInt(0 - obj.situacao)
        obj.situacao = situation
        ExpenseRepository.SetDisapproved(obj.id, situation)
          .then((response) => {
            this.onResult(response)
            this.objSelected = obj
            this.$refs.DetailsHeader.obj = obj
            loading.close()
          })
          .catch(this.onException)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/miscellaneous/attachment/attachment.vue